import React, { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";

import SimpleImage from "../../Shared/Media/SimpleImage";
import CorporatePurposeImg from "../../../assets/images/CorporatePurpose.webp";
import { FormattedMessage } from "react-intl";
import CardHeader from "../../Shared/Common/Card/CardHeader";

const CorporatePurpose: FC = () => {
  return (
    <div className="corporate-purpose-area">
      <Container>
        <CardHeader title={"page.about.corporate_purpose.title"}></CardHeader>
        <Row>
          <Col sm={12} md={12} lg={6} className="corporate-purpose-cont">
            <p>
              <FormattedMessage
                id={"page.about.corporate_purpose.description"}
                values={{ br: <br /> }}
              />
            </p>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <SimpleImage src={CorporatePurposeImg} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default CorporatePurpose;
